import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addDatosSustancia } from "../../../../../../redux/actions/resolucion";
import SustanciaFormPart1 from "./SustanciaFormPart1";

const initialValues = {
    nombre: "",
    sustancia: null,
    cantidad: "",
    unidad: "",
};

const SustanciasFormPart1Container = ({ handleCancelSustancia, setFormPart, stepper }) => {
    const dispatch = useDispatch();
    const sustancias = useSelector((state) => state.resolucion.sustancias.data);
    const sustanciasAgregadas = useSelector((state) => state.resolucion.postResolucion.sustancias);
    const sustancia = useSelector((state) => state.resolucion.abmSustancia);

    const [formModel, setFormModel] = useState(sustancia?.sustancia ?? initialValues);

    const handleSubmit = (sustancia) => {

        const codigoSustanciaYDescripcion = sustancias.find((v) => v.id === sustancia.sustancia)?.nombre


        dispatch(addDatosSustancia({
            ...sustancia,
            nombreAgente: codigoSustanciaYDescripcion.split(" - ")[0],
            descripcionAgente: codigoSustanciaYDescripcion.split(" - ")[1],
        }));
        setFormPart("Part2");
    }

    return (
        <SustanciaFormPart1
            formModel={formModel}
            handleSubmit={handleSubmit}
            handleCancelSustancia={handleCancelSustancia}
            stepper={stepper}
            sustanciasAgregadas={sustanciasAgregadas}
            sustancia={sustancia}

        />
    )

}

export default SustanciasFormPart1Container;